export default {
    first: 'es',
    es: {
        user: 'Email',
        perfil: 'Perfil',
        history: 'Historial',
        misReservas: 'Mis reservas',
        reservasAceptadas: 'Reservas aceptadas',
        promotions: 'Promociones',
        currentAccount: 'Cuenta corriente',
        compartir: 'Compartir',
        toc: 'Términos y condiciones',
        registrameComoChofer: 'Registrarme como chofer',
        contacto: 'Contacto',
        chapa: 'NRO de identificación de móvil',
        documentacionNecesaria: 'Por favor adjunta las imágenes de la siguiente documentación para poder validarte como chofer: 1- Licencia de conducir 2- Habilitacion municipal 3- Póliza de seguro 4- DNI',
    },
    en: {
        user: 'Email',
        perfil: 'Profile',
        history: 'History',
        misReservas: 'My reservations',
        reservasAceptadas: 'Accepted reservations',
        promotions: 'Promotions',
        currentAccount: 'Current Account',
        compartir: 'Share',
        toc: 'Terms and conditions',
        registrameComoChofer: 'Sign up as driver',
        contacto: 'Contact us',
        chapa: 'Vehicle ID',
        documentacionNecesaria: 'Please attach the images of the following documentation to be able to validate you as a driver: 1- driver license 2- Municipal authorization 3- Insurance policy 4- ID',
    }
};



// WEBPACK FOOTER //
// ./src/assets/language/language.holataxi.js